import { Link } from "./link.js";
import { LinkStyles, LinkTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
/**
 * The Fabric Link component.
 *
 * @public
 */
export const definition = Link.compose({
    name: `${DesignSystem.prefix}-link`,
    template: LinkTemplate,
    styles: LinkStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=link.definition.js.map